'use client'

import { InstructionsSizeDrawer } from '@/app/[locale]/product/[slug]/_components/product-info-sizes/instruction-size-drawer'
import { Divider } from '@/components/ui/divider'
import { useTranslations } from 'next-intl'
import { useMemo, useState } from 'react'
import { useBoolean } from 'usehooks-ts'

type Props = {
  sizeChart: string
}

export const InstructionSize = ({ sizeChart }: Props) => {
  const t = useTranslations('product_detail.instruction_size')
  const drawerControl = useBoolean()
  const [activeTab, setActiveTab] = useState('size-table')

  const isBraOrLegging = useMemo(
    () => ['BRA', 'LEGGING'].includes(sizeChart),
    [sizeChart]
  )

  // Cấu hình các tuỳ chọn nút
  const buttonOptions = useMemo(() => {
    const options = [
      {
        label: isBraOrLegging ? t('size_table') : t('choose_size'),
        value: 'size-table',
      },
    ]

    if (isBraOrLegging) {
      options.push({
        label: t('choose_size'),
        value: 'guide',
      })
    }

    return options
  }, [isBraOrLegging, t])

  const openDrawer = (tabValue: string) => {
    setActiveTab(tabValue)
    drawerControl.setTrue()
  }

  return (
    <div className='flex items-center py-1'>
      {buttonOptions.map((option, index) => (
        <div key={option.value} className='flex items-center'>
          {index > 0 && <Divider className='mx-2 h-4.5' type='vertical' />}
          <button
            className='font-sans text-sm leading-4.5 text-primary underline'
            onClick={() => openDrawer(option.value)}
          >
            {option.label}
          </button>
        </div>
      ))}

      {drawerControl.value && (
        <InstructionsSizeDrawer
          onCancel={drawerControl.setFalse}
          tabDefault={activeTab}
          sizeChart={sizeChart}
        />
      )}
    </div>
  )
}
